export const fields = `
  isHidden,
  cmsTitle,
`

export const fragment = (name = 'cmsSettings') => `${name}{ ${fields} }`

export default fragment
